import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

interface IUpdate extends IReduxState<ISlotList> {
  spaceupdateableDate?: ISlotList;
}

export const UpdateSpaceSlicer = createSlice({
  name: 'UpdateSpace',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateSpace: (state, _) => {
      state.isLoading = true;
    },
    successUpdateSpace: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateSpace: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    SpacesUpdateableData: (state, action) => {
      state.spaceupdateableDate = action.payload;
    },
    clearUpdateSpaceState: (state) => {
      state.data = {};
      state.spaceupdateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.spaceupdateableDate = undefined;
    },
  },
});

export const {
  updateSpace,
  failureUpdateSpace,
  successUpdateSpace,
  SpacesUpdateableData,
  clearUpdateSpaceState,
  clearUpdateableData,
} = UpdateSpaceSlicer.actions;

export default UpdateSpaceSlicer.reducer;
